import React from 'react';
import moment from 'moment';
import map from 'lodash/map';

import './index.css';

class JerseysList extends React.Component {
    render() {
        const { jerseysList, title, onAdd } = this.props;
        return (
            <div id="JerseysList" className="col-md-6">
                <div className="box box-default">
                    <div className="box-header with-border">
                        <h3 className="box-title pull-left">
                            {title}
                        </h3>
                    </div>
                    <div className="table-fixed-height">
                        <table className="table table-responsive table-striped">
                            <thead>
                            <tr>
                                <th />
                                <th>ID</th>
                                <th>NAME</th>
                                <th>CREATION</th>
                                <th />
                            </tr>
                            </thead>
                            <tbody>
                            {
                                jerseysList && map(jerseysList, jersey => {
                                    return (
                                        <tr key={jersey.id}>
                                            <td>
                                                <img
                                                    style={{ width: '30px' }}
                                                    src={`${jersey.imageUrl}?nocache=${new Date()}`}
                                                    alt=""
                                                />
                                            </td>
                                            <td>{jersey.code}</td>
                                            <td>{jersey.nameFr}</td>
                                            <td>{moment(jersey.startDate).format('DD/MM/YY')}</td>
                                            <td>
                                                <button
                                                    className="btn btn-success"
                                                    onClick={() => onAdd(jersey.id)}
                                                >
                                                    Add
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default JerseysList;



// WEBPACK FOOTER //
// ./src/pages/Jerseys/CollectionsList/jerseysList.js